<template>
    <main>

    </main>
</template>

<script>
    import Crumbs from "../../components/pc/Crumbs";
    export default {
        name: 'auth',
        data() {
            return {
                query:"",
            }
        },
        components:{
            Crumbs
        },
        computed:{
            crumbs() {
                return [

                ]
            },
        },
        methods: {
			getSign(){
				if(!this.query.redirect){
					return false;
				}
				this.http.request({
					api:"mudu/assignUser",
					data:{
						return:this.query.redirect,
						live_code:this.query.live_code
					},
					loading:true,
					success:(res)=>{
						if(this.$route.query.target){
							this.$router.replace(this.$route.query.target)
							window.open(res.url);
						}else{
							window.location.href = res.url;
						}
					}
				})
			},
			userLogin(){
				var user_info = this.$store.state.user_info;
				var eventNumber = this.query.live_event;
				var live_code = this.query.live_code;
                this.http.request({
                    api:"mudu/passwordLessLogin",
                    data:{
						openid:user_info.id,
						//username:user_info.username,
						mobile:this.util.encryptPhone(user_info.mobile),
						eventNumber:eventNumber,
                    },
                    loading:true,
                    success:(res)=>{
						var access_token = res.access_token;
						window.location.href = `https://event.mudu.com/event/${eventNumber}/watch/${live_code}?s=${access_token}`;
                    }
                })
            },
			authorizeOld(){
				this.http.request({
					api:"mudu/authorizeOld",
					data:{
						return:this.query.redirect,
						live_code:this.query.live_code
					},
					loading:true,
					success:(res)=>{
						if(this.$route.query.target){
							this.$router.replace(this.$route.query.target)
							window.open(res.url);
						}else{
							window.location.href = res.url;
						}
					}
				})
			},
			toLive(){
				const id = this.query.live_code || '';
				const branch = this.query.branch || '1';
        // 主会场+AI赋能生产力+AI赋能数据用的主会ID：6227216
        // 合作伙伴用的主会ID：6227229
				const url = `https://www.dellemc-solution.com/webinar-dtf/?channelId=${id}&mainId=${branch == '2' ? '6227229' : '6227216'}#/`;

				if(this.$route.query.target){
					this.$router.replace(this.$route.query.target)
					window.open(url);
				}else{
					window.location.href = url;
				}
			}
        },
        mounted() {
			document.title = "正在进入直播间";
            this.query = this.$route.query;
			this.toLive();
			// if(Number(this.query.live_type) === 2){
			// 	this.authorizeOld();
			// }else{
			// 	this.userLogin();
			// }
			gio('track', 'DTF2021_jumptomudulive', {
				'DTF_webinartitle':this.query.title,
			});
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .message{height:200px;line-height: 200px;width: 1200px;margin: 0 auto;}
</style>

